import { createPendoClient } from '@klareospace/pharos-lib-web-utils';
import { env } from '&/config';

/**
 * Pendo web agent singleton for the frontoffice app.
 *
 * When VITE_PENDO_API_KEY is empty (develop/staging), a no-op client is returned —
 * no script is loaded, no network calls, no errors.
 */
export const pendoClient = createPendoClient({ apiKey: env.pendoApiKey });
